"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/tabs/style");
var _tabs = _interopRequireDefault(require("antd/lib/tabs"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TabPane = _tabs.default.TabPane;
var AntdTab = function AntdTab(props) {
  return /*#__PURE__*/_react.default.createElement(TabPane, props, props.children);
};
var _default = AntdTab;
exports.default = _default;